<order-translations></order-translations>
<div class="row content-container">
  <div class="col-12 col-sm-12 main-content mynovi mynovi--order-detail">
    @if (!confirmed) {
      <div class="button-bar button-bar--justify">
        @if (!showBarcode) {
          <a [routerLink]="['/products']">
            <strong>
              <svg class="icon-arrow-left" height="10" viewBox="0 0 6 10" width="6">
                <use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
              </svg>
              <span i18n="Back to products link text@@back.to.products">
            Back to products
          </span>
            </strong>
          </a>
        }
        @if (showBarcode) {
          <a (click)="showBarcode = false">
            <strong>
              <svg class="icon-arrow-left" height="10" viewBox="0 0 6 10" width="6">
                <use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
              </svg>
              <span i18n="Back to shopping cart@@back.to.shoppingcart">
            Back to shopping cart
          </span>
            </strong>
          </a>
        }
      </div>
    }

    @if (confirmed) {
      <div class="shoppingcart-confirmation-message">
        <h1 class="">
          <span class="icon-check-wrapper-rounded">
            <svg class="icon-check" height="9" width="12">
              <use xlink:href="/images/icons/svg-sprite.svg#check"></use>
            </svg>
          </span>
          <span i18n="Thank you for your order text@@shoppingcart.thank.you">
          Thank you for your order
        </span>
        </h1>
        <a
          [routerLink]="['/products']"
          class="button"
          i18n="@@shoppingcart.to.assortment"
          >Continue to assortment</a
          >
        </div>
      }

      @if (!showBarcode) {
        <h1 class="order-detail-title">
          <span i18n="@@shoppingcart.title">Shopping cart</span>
        </h1>
      }

      @if (showBarcode) {
        <h1 i18n="@@add.barcodes">Add barcodes</h1>
        <p>&nbsp;</p>
        <!-- <span>'s binnen de h3 zorgen ervoor dat de datum en locatie los van elkaar op een nieuwe regel breken als het scherm kleiner wordt -->
        <h4 class="order-detail-title">
          @if (activeOrder && activeOrder.shipmentDate) {
            <span>{{
              activeOrder.shipmentDate | customDate: "EEEE dd MMMM"
            }}</span>
          }
          -
          @if (activeOrder && activeOrder.deliveryAddress) {
            <span data-private>{{
              activeOrder.deliveryAddressName
            }}</span>
          }
        </h4>
      }

      @if (!showBarcode) {
        <div
          class="order-detail-info order-detail-info--align"
          >
          <dl>
            <dt i18n="shopping cart: total volume@@shoppingcart.total.volume">
          Total volume
        </dt>
            <dd>{{ getTotalVolume() | numberFormat: false }} CC</dd>
          </dl>
          <dl>
            <dt i18n="shopping cart: total price@@shoppingcart.total.price">
          Total amount
        </dt>
            <dd>
              {{ applicationService.getUserCurrency() }}
              {{ getTotalPrice() | numberFormat: true }}
            </dd>
          </dl>
          <dl>
            <dt i18n="shopping cart: closes@@order.closes">Closes</dt>
            <dd>{{ closingTimeString }}</dd>
          </dl>
        </div>
      }

      @if (!showBarcode) {
        <div
          class="order-detail-info order-detail-info--align"
          >
          <dl>
            <dt i18n="shopping cart: shipping date@@shipping.date">
          Shipping date
        </dt>
            @if (activeOrder && activeOrder.shipmentDate) {
              <dd>
                {{ activeOrder.shipmentDate | customDate: "EEEE dd MMMM" }}
              </dd>
            }
          </dl>
          <dl>
            <dt i18n="shopping cart: delivery date@@delivery.date">
          Delivery date
        </dt>
            @if (activeOrder && activeOrder.deliveryDate) {
              <dd>
                {{
                activeOrder.deliveryDate.deliveryDate | customDate: "EEEE dd MMMM"
                }}
              </dd>
            }
          </dl>
          <dl>
            <dt i18n="shopping cart: shipping destination@@shipping.destination">
          Shipping destination
        </dt>
            @if (activeOrder && activeOrder.deliveryAddressName) {
              <dd>
                {{ activeOrder.deliveryAddressName }} ({{ activeOrder.shipToCode }})
              </dd>
            }
          </dl>
        </div>
      }

      <div class="button-bar button-bar--justify button-bar--va-bottom">
        <div class="text-center" sales-person-telephone></div>

        @if (isConfirmAllEnabled()) {
          <a
            (click)="confirmAll()"
            class="button button--green"
            i18n="shopping cart: confirm order@@shoppingcart.confirm.order"
            >Confirm order
      </a>
        }
      </div>

      @if (showBarcode) {
        <div
          class="button-bar button-bar--justify button-bar--va-bottom"
          >
          <div class="text-center">&nbsp;</div>
          <a
            (click)="confirmBarcodes()"
            class="button"
            i18n="Confirm barcodes link@@confirm.barcodes"
            >Confirm barcodes</a
            >
          </div>
        }

        <div
          class="grid-container grid-table-filter-bar table-filter-bar start-1 grid-1-mobile"
          >
          <div class="grid-item">
            @if (showBarcode) {
              <form
                class="grid-container grid-custom-6 factorForm"
                >
                <label
                  [for]="factorForm.controls['factor']"
                  i18n="Barcode: factor@@barcode.factor"
                  >Factor</label
                  >
                  <input
                    [formControl]="factorForm.controls['factor']"
                    pattern="[0-9]*[.,]?[0-9]+"
                    type="text"
                    value="1.00"
                    />
                  <label
                    [for]="factorForm.controls['rounding']"
                    i18n="Barcode: Rounding@@barcode.rounding"
                    >Rounding</label
                    >
                    <div class="custom-select">
                      <select [formControl]="factorForm.controls['rounding']">
                        <option>0.01</option>
                        <option>0.02</option>
                        <option>0.05</option>
                        <option>0.10</option>
                        <option>0.25</option>
                        <option>0.50</option>
                        <option>1.00</option>
                      </select>
                    </div>
                    <button
                      (click)="updateBarcodeSalesPrices()"
                      class="button button--small"
                      i18n="Update barcode button label@@update.barcode.button"
                      type="button"
                      >
            Update
          </button>
                  </form>
                }
              </div>
              <div class="grid-item">
                <form class="overview-sort sortOnForm align-right">
                  <label
                    [for]="sortForm.controls['sort']"
                    i18n="Barcode view: Sort on@@barcode.sort.on"
                    >Sort on:</label
                    >
                    <div class="custom-select">
                      <select [formControl]="sortForm.controls['sort']">
                        <option
                          i18n="sort on: description@@sort.on.description"
                          value="description"
                          >
                Description a-z
              </option>
                        <option
                          i18n="sort on: date inserted@@barcode.sort.on.inserted"
                          value="inserted"
                          >
                Date inserted
              </option>
                        <option
                          i18n="sort on: without barcode@@barcode.sort.on.without.barcode"
                          value="barcode"
                          >
                Without barcode
              </option>
                        <option
                          i18n="sort on: volume@@barcode.sort.on.volume"
                          value="volume"
                          >
                Volume
              </option>
                        <option
                          i18n="sort on: amount & unit@@barcode.sort.on.amount.unit"
                          value="quantity"
                          >
                Amount
              </option>
                      </select>
                    </div>
                  </form>
                </div>
              </div>

              <div class="table-container">
                <table class="order-overview-table">
                  <thead>
                    @if (confirmed) {
                      <tr class="order-overview-table_head--confirmed">
                        <td colspan="6" i18n="@@shoppingcart.confirmed">Confirmed:</td>
                      </tr>
                    }
                    <tr>
                      <th
                        colspan="2"
                        i18n="shopping cart: header product@@product.title"
                        scope="col"
                        >
              Product
            </th>
                      <th
                        i18n="shopping cart: header amount & unit@@amount.unit.title"
                        scope="col"
                        >
              Amount
            </th>
                      <th i18n="shopping cart: header volume@@order.volume" scope="col">
              Volume
            </th>
                      @if (showBarcode) {
                        <th
                          i18n="shopping cart: barcode header@@order.barcode"
                          scope="col"
                          >
              Barcode
            </th>
                      }
                      <th i18n="shopping cart: header price@@order.price" scope="col">
              Price
            </th>
                      <th></th>
                    </tr>
                  </thead>
                  @for (line of shoppingCartLines; track line) {
                    <tbody>
                      <tr
                        [closingTime]="closingInHours"
                        [isEditable]="!confirmed"
                        [shoppingCartLine]="line"
                        [showBarcode]="showBarcode"
                        shopping-cart-row
                      ></tr>
                      @if (showBarcode) {
                        <tr
                          #addbarcode
                          (addBarCode)="addBarcode($event, line)"
                          [shoppingCartLine]="line"
                          add-barcode-row
                          class="add-barcode-row"
                        ></tr>
                      }
                    </tbody>
                  }
                  @if (!showBarcode) {
                    <tfoot>
                      <tr>
                        <td
                          class="order-overview-table_footer-total--label"
                          colspan="3"
                          i18n="@@order.detail.total"
                          >
              Total:
            </td>
                        <td class="order-overview-table_footer-total--volume">
                          {{ getTotalVolume() | numberFormat: false }}
                          CC
                        </td>
                        @if (showBarcode) {
                          <td
                            class="order-overview-table_footer-total--volume"
                            >
                            &nbsp;
                          </td>
                        }
                        <td class="order-overview-table_footer-total--price" colspan="2">
                          {{ applicationService.getUserCurrency() }}
                          {{ getTotalPrice() | numberFormat: true }}
                        </td>
                      </tr>
                    </tfoot>
                  }
                </table>
              </div>

              <div class="button-bar button-bar--right">
                @if (isConfirmAllEnabled()) {
                  <a
                    (click)="confirmAll()"
                    class="button button--green theme-btn-success"
                    i18n="shopping cart: confirm order@@shoppingcart.confirm.order"
                    >Confirm order
      </a>
                }
                @if (confirmed) {
                  <a
                    [routerLink]="['/products']"
                    class="button theme-btn-primary"
                    i18n="@@shoppingcart.to.assortment"
                    >
        Continue to assortment
      </a>
                }
                @if (showBarcode) {
                  <a
                    (click)="confirmBarcodes()"
                    class="button theme-btn-primary"
                    i18n="Confirm barcodes link@@confirm.barcodes"
                    >
        Confirm barcodes
      </a>
                }
              </div>

              @if (confirmed) {
                <div class="banner-fast-buy">
                  <h3 i18n="@@shoppingcart.immediate.confirmation">
        Immediate confirmation next time?
      </h3>
                  <p i18n="@@buy.now.description">
        Shop current inventory using 'buy now' and be guaranteed of delivery on
        all selected products.
      </p>
                  <ul>
                    <li>
                      <svg class="icon-check" height="9" width="12">
                        <use xlink:href="/images/icons/svg-sprite.svg#check"></use>
                      </svg>
                      <span i18n="@@buy.now.garanteed.delivery"
                        >Delivery guaranteed on selected products</span
                        >
                      </li>
                      <li>
                        <svg class="icon-check" height="9" width="12">
                          <use xlink:href="/images/icons/svg-sprite.svg#check"></use>
                        </svg>
                        <span i18n="@@buy.now.next.day.delivery"
                          >Next-day delivery on all products (when available)</span
                          >
                        </li>
                      </ul>
                      <a [routerLink]="['/my/preferences']" class="button button--secondary">
                        <span i18n="Enable Buy Now text@@shoppingcart.buy.now.button">
          Enable Buy Now
        </span>
                        <svg class="icon-truck" height="13" width="32">
                          <use xlink:href="/images/icons/svg-sprite.svg#truck"></use>
                        </svg>
                      </a>
                    </div>
                  }
                </div>
              </div>
